import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=ded68130&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=ded68130&lang=scss&scoped=true"
import style1 from "./layout.vue?vue&type=style&index=1&id=ded68130&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded68130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ded68130')) {
      api.createRecord('ded68130', component.options)
    } else {
      api.reload('ded68130', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=ded68130&scoped=true", function () {
      api.rerender('ded68130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collegeEdition/layout.vue"
export default component.exports